export enum PayerFinanceRequestMakerPermissions {
  ViewInstruments = 'view_documents',
  ViewInstrumentDetails = 'view_instrument_details',
  ViewInstrumentAttachments = 'view_instrument_attachments',
  ReviewInstruments = 'review_instruments',
  RejectInstruments = 'reject_instruments',
}
